"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SendScheduleOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_SendScheduleOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.234 2 13.224.009c.409 0 .715.5.435.902l-2.86 4.113a4.552 4.552 0 0 1 1.194.034l2.487-3.576c.722-1.037-.006-2.472-1.255-2.473L1.235 1C.077 1-.442 2.477.454 3.224L3.746 5.97a1.62 1.62 0 0 0 1.555.294l3.494-1.172c.443-.149.748.451.372.734l-2.96 2.223c-.452.34-.702.89-.664 1.461l.295 4.322c.08 1.176 1.565 1.6 2.235.638l.516-.742a4.472 4.472 0 0 1-.449-1.107l-.888 1.278c-.044.063-.084.083-.112.093a.224.224 0 0 1-.13 0 .243.243 0 0 1-.12-.075.25.25 0 0 1-.054-.153l-.295-4.322a.684.684 0 0 1 .266-.593l2.96-2.224c.638-.478.68-1.253.413-1.78-.27-.531-.933-.96-1.703-.7L4.983 5.314a.62.62 0 0 1-.596-.114L1.094 2.456a.239.239 0 0 1-.087-.13.29.29 0 0 1 .01-.163c.022-.059.055-.1.087-.125A.2.2 0 0 1 1.234 2ZM13 10a.5.5 0 0 0-1 0v1.5a.5.5 0 0 0 .146.354l1 1a.5.5 0 0 0 .708-.708L13 11.293V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM10 11.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_SendScheduleOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = SendScheduleOutline;
exports["default"] = _default;